import FilterModal, {
  FilterGroup,
} from 'components/Filters/components/FilterModal'

import { FilterIdentifier } from 'models/saved_view'
import { filterStoreRepo } from '../../Filters/FilterStore'
import { createFilterColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { SELECT_LOCATIONS } from './selectLocationsForDealColumnInfo'
import { CityAndStateFilter } from 'components/Filters/components/CityAndStateFilter'
import { ZipcodeFilter } from 'components/Filters/fields/ZipcodeFilter'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { DMA_OPTIONS } from 'models/dma_options'

export function DealsFilterset(props: {
  filterIdentifier: FilterIdentifier
  hideCampaignsFilter?: boolean
}) {
  const selectLocationsForDealFilterStore = filterStoreRepo.getStore(
    props.filterIdentifier
  )

  const selectLocationsForDealFilterHelper = createFilterColumnHelper({
    columns: SELECT_LOCATIONS,
  })

  return (
    <FilterModal
      store={selectLocationsForDealFilterStore}
      identifier={props.filterIdentifier}
      disableSavedFilters
    >
      <FilterGroup title={'Target Details'}>
        <CityAndStateFilter
          filterStore={selectLocationsForDealFilterStore}
          citySelectProps={selectLocationsForDealFilterHelper.retrieveProps(
            'city'
          )}
          stateSelectProps={selectLocationsForDealFilterHelper.retrieveProps(
            'state'
          )}
        />
        <ZipcodeFilter filterStore={selectLocationsForDealFilterStore} />
        <SelectFilter
          filterStore={selectLocationsForDealFilterStore}
          {...selectLocationsForDealFilterHelper.retrieveProps('dma')}
          options={DMA_OPTIONS}
        />
      </FilterGroup>
    </FilterModal>
  )
}
